<template>
  <section>
    <!-- Listing Header -->
    <user-header @search="search" @add="addUser" />
    <!-- Listing -->
    <div class="custom-wrapper">
      <z-table
        :value="userList"
        sortBy="id"
        orderBy="asc"
        :columns="tableColumns"
        :isSingleRowDetail="true"
        @sort="setOrder"
        class="table table-bordered table-striped"
      >
        <template v-slot:tbody="props">
          <th scope="row" class="z-column-80">{{ props.row.id }}</th>
          <td class="z-column-60-center">
            <a href="#" @click="editUser(props.row)">edit</a>
          </td>
          <td class="z-column-60-center">
            <img :src="props.row.Avatar" class="custom-avatar" />
          </td>
          <td>{{ props.row.LastName }}</td>
          <td>{{ props.row.FirstName }}</td>
          <td>{{ props.row.NickName }}</td>
          <td>{{ props.row.email }}</td>
          <td>{{ props.row.OrgName }}</td>
          <td class="z-column-60-center">
            <a href="#" @click="remove(props.row)">remove</a>
          </td>
        </template>
        <template v-slot:detail="props">
          <user-record :recordData="props.row" />
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <user-dialog
      id="user-modal"
      :show="actionUser"
      @close="closeModal"
      @saved="savedUser"
      @deleted="deletedUser"
    />
    <confirm-remove
      :show="actionConfirmRemove"
      :confirmTitle="confirmTitleRemove"
      :confirmAction="confirmActionRemove"
      :confirmQuestion="confirmQuestionRemove"
      @closing="closeModal"
      @proceed="performRemove"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZTable from '@/Components/ZElements/Table'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
import UserHeader from '@/Components/Users/user-header'
import UserCheckbox from '@/Components/Users/user-checkbox'
import UserDialog from '@/Components/Users/forms/user-dialog'
import UserRecord from '@/Components/Users/user-record'
export default {
  name: 'user-listing',
  components: {
    ZTable,
    ConfirmRemove,
    UserHeader,
    UserCheckbox,
    UserDialog,
    UserRecord,
  },
  data() {
    return {
      page: 1,
      actionUser: null,
      itemId: null,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove: 'Are you sure you wish to remove this User?',
      actionConfirmRemove: null,
    }
  },
  async mounted() {
    this.itemId = null
    await this.getStateProvinces()
    await this.getTimezones()
    await this.search()
  },
  computed: {
    ...mapGetters('users', ['users', 'user', 'pager']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'Avatar',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'LastName', label: 'Last', sortable: true },
        { field: 'FirstName', label: 'First', sortable: true },
        { field: 'NickName', label: 'Nickname', sortable: true },
        { field: 'email', label: 'Email', sortable: true },
        { field: 'OrgName', label: 'Organization', sortable: true },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
    userList() {
      let _users = []
      if (this.users) {
        _users = JSON.parse(JSON.stringify(this.users))
        _users.forEach((user) => {
          user.isDetailVisible = false
        })
      }
      return _users
    },
  },
  methods: {
    ...mapActions('configuration', ['getStateProvinces', 'getTimezones']),
    ...mapActions('users', [
      'getRoles',
      'getUsers',
      'getUser',
      'setPager',
      'resetUser',
      'removeUser',
    ]),
    async search() {
      try {
        await this.getUsers({
          page: this.pager.page,
          pageSize: this.pager.pageSize,
          sortBy: this.pager.sortBy,
          orderBy: this.pager.orderBy,
          search: this.pager.search,
        })
        window.app.$forceUpdate()
      } catch (e) {
        console.log('Error', e)
      }
    },
    async setOrder(column, order) {
      this.setPager({
        name: 'sortBy',
        value: column.field,
      })
      this.setPager({
        name: 'orderBy',
        value: order,
      })
      await this.search()
    },
    closeModal() {
      this.actionConfirmRemove = null
      this.actionUser = null
    },
    savedUser() {
      this.search()
    },
    deletedUser() {
      this.search()
    },
    async addUser() {
      this.resetUser()
      await this.getRoles({
        id: 1,
      })
      this.actionUser = {
        isAdd: true,
        cameFrom: 1,
        data: null,
      }
    },
    async editUser(data) {
      await this.getUser(data.id)
      this.isAdd = false
      this.actionUser = {
        isAdd: false,
        cameFrom: 1,
        data: data,
      }
    },
    remove(data) {
      this.itemId = data.id
      this.actionConfirmRemove = true
    },
    async performRemove() {
      this.actionConfirmRemove = null
      // Perform Removal
      await this.removeUser(this.itemId)
      this.search()
      this.itemId = null
    },
  },
}
</script>
<style lang='scss'>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-avatar {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
</style>
